import Link from "@mui/material/Link";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Setter } from "../_/utils/ReactUtils";
// import { Link } from "react-router-dom";


type Props = {
    text: string
    icon: ReactNode,
    link: string,
}


const MenuListItem = ({ text, icon, link, }: Props) => {
    const navigate = useNavigate();
    const handleClick = () => {
        navigate(link)
      };
    
    return(
    <ListItem key={text} disablePadding>
            <ListItemButton onClick={handleClick} >
                <ListItemIcon>
                    {icon}
                </ListItemIcon>
                <ListItemText primary={text} />
            </ListItemButton>
    </ListItem>
)};

export default MenuListItem
